module.exports = __webpack_public_path__ + "static/media/fulcro-white-logo.171fc11a.svg";